import React from "react";
import PropTypes from "prop-types";
import { Translate } from "react-redux-i18n";
import { GridColumn, GridRow } from "@react/react-spectrum/Grid";

import "./RestrictedCountryBanner.scss";

function RestrictedCountryBanner({ visible }) {
  if (!visible) {
    return null;
  }

  return (
    <GridRow>
      <GridColumn size={[12, 10, 10, 8]} offsetSize={[0, 1, 1, 2]}>
        <div className="restricted-country-banner" role="status">
          <Translate value="managePartnership.restrictedSanctionBannerMessage" />
        </div>
      </GridColumn>
    </GridRow>
  );
}

RestrictedCountryBanner.propTypes = {
  visible: PropTypes.bool,
};

RestrictedCountryBanner.defaultProps = {
  visible: false,
};

export default RestrictedCountryBanner;
